export default __webpack_public_path__ + "static/media/user1.8576bf1d.jpg";